import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { AgentRolesType } from "@/utils";

const tokenExpireTransformFactor = 1000;

export interface User {
  name: string;
  role: AgentRolesType;
}

export interface UserStoreState {
  user: User | null;
  setUser(user: User | null): void;
  token: string | null;
  setToken(token: string | null): void;
  clearUser: () => void;
  tokenExpiresAt: Date | null;
  setTokenExpiresAt(tokenExpiresIn: number): void;
  isTokenExpired(): boolean;
  isTwoFaAuthenticated: boolean;
  setIsTwoFaAuthenticated(isAuthenticated: boolean): void;
}

export const useUserStore = create<UserStoreState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      tokenExpiresAt: null,
      isTwoFaAuthenticated: false,
      setUser: (user: User | null) => {
        set(() => ({ user }));
      },
      clearUser: () => {
        set({
          user: null,
          token: null,
          tokenExpiresAt: null,
          isTwoFaAuthenticated: false,
        });
      },
      setToken: (token: string | null) => {
        set(() => ({ token }));
      },
      setTokenExpiresAt: (tokenExpiresIn: number) => {
        const expirationDate = new Date(
          Date.now() + tokenExpiresIn * tokenExpireTransformFactor,
        );
        set(() => ({ tokenExpiresAt: expirationDate }));
      },
      isTokenExpired: () => {
        const { tokenExpiresAt } = get();
        return tokenExpiresAt ? tokenExpiresAt < new Date() : true;
      },
      setIsTwoFaAuthenticated: (isAuthenticated: boolean) => {
        set(() => ({ isTwoFaAuthenticated: isAuthenticated }));
      },
    }),
    {
      name: "feedbackUserStore",
    },
  ),
);
